import {Component, EventEmitter, Inject, Input} from '@angular/core';
import {HelpModel} from '@spout/global-web/models';
import {Observable, Subject} from 'rxjs';
import {CONTAINER_DATA, ContentModel} from '../content.model';

@Component({
  selector: 'spt-help-getting-started-reviewing',
  templateUrl: './help-getting-started-reviewing.component.html',
  styleUrls: ['./help-getting-started-reviewing.component.scss']
})
export class HelpGettingStartedReviewingComponent implements ContentModel {
  static ref = HelpModel.GETTING_STARTED_REVIEWING;
  static title = 'Getting Started Reviewing';

  showBackHeader = true;

  helpTitle = HelpGettingStartedReviewingComponent.title;

  private modalClose: Subject<any> = new Subject();

  onModalClose(): Observable<any> {
    return this.modalClose.asObservable();
  }

  constructor(@Inject(CONTAINER_DATA) private data: ContentModel) {
    if (this.data) {
      this.showBackHeader = this.data.showBackHeader;
    }
  }

  closeModal() {
    this.modalClose.next(null);
    this.modalClose.complete();
  }
}
